import { Card, IconButton } from "@shared/ui"

import * as st from './styles.module.scss';
import { Group, Mark } from "@shared/assets";
import type { ReactNode } from "react";
import cn from 'classnames';


const Circle = ({ isChecked }: { isChecked: boolean }) => {


    return (
        <div className={st.circle}>
            <IconButton
                size="small"
                className={cn(isChecked && st.circle__checked)}
                onClick={() => null}
            >
                {isChecked && <Mark />}
            </IconButton>
        </div>
    )
}

const GroupIcon = () => {
    return (
        <div className={st.group}>
            <Group />
        </div>
    )
}


interface Props {
    isChecked: boolean;
    onCheck: () => void;
    children?: ReactNode;
}


export const GroupItem = ({ isChecked, onCheck, children }: Props) => {
    return (
        <Card className={st.item}>
            <div onClick={onCheck}>
                <Circle isChecked={isChecked} />
            </div>
            <GroupIcon />
            <span className={st.item__text}>
                {children}
            </span>
        </Card>
    )
}  